var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNaturalHazards = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 36",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.928 23.63 19.375 26.1A1.721 1.721 0 0 1 16.2 25.07l.215-3.165h-.558c.018 2.526.084 8.264-.536 9.61-.68 1.479-1.039 2.226-.32 2.226h6.79c.72 0 .36-.747-.32-2.227-.502-1.09-.553-5.071-.544-7.884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.917 13.034c.525-1.524-.22-3.52-1.924-4.832-1.269-.976-2.765-1.34-4-1.093q-.064.014-.13.029c-.4-1.624-2.242-2.855-4.465-2.88-2.225.024-4.067 1.256-4.467 2.88l-.13-.03c-1.235-.245-2.731.118-4 1.094-1.705 1.312-2.448 3.308-1.923 4.832a5.253 5.253 0 1 0 5.832 8.723 1.721 1.721 0 0 1-.792-2.447l4.223-7.18a1.72 1.72 0 0 1 1.915-.795l2.355.611c.524.136.952.508 1.158 1.007.208.499.168 1.065-.105 1.531l-.963 1.638h1.028a1.722 1.722 0 0 1 1.458 2.636l-1.539 2.45a5.253 5.253 0 1 0 6.47-8.173"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.624 13-4.222 7.183h3.855l-.339 5.003 4.61-7.343h-4.035l2.488-4.231z"
  })));
};
export default SvgNaturalHazards;